/**
 * Hover riêng cho từng nút của thanh công cụ tab Công việc — APM-UX-ai6.
 *
 * Viền `outline` mặc định của `Button` chỉ đổi sang `bg-muted` (xám) khi
 * hover — cùng một xám cho mọi nút. Bốn nút cạnh nhau (Sửa nhanh, Kế hoạch,
 * Việc mới, Sửa biểu đồ) mỗi nút tô một màu nhạt riêng để phân biệt được
 * bằng mắt trước cả khi đọc chữ, và tô **nhạt** (opacity thấp) để vẫn khớp
 * nền `outline` sáng màu, không biến thành bốn nút đặc màu chọi nhau.
 */
export const BULK_EDIT_HOVER =
  'transition-colors hover:border-violet-500/40 hover:bg-violet-500/10';
export const PLAN_HOVER = 'transition-colors hover:border-blue-500/40 hover:bg-blue-500/10';
export const NEW_TASK_HOVER =
  'transition-colors hover:border-emerald-500/40 hover:bg-emerald-500/10';
export const GANTT_EDIT_HOVER = 'transition-colors hover:border-amber-500/40 hover:bg-amber-500/10';
